import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SidebarBrandLogoComponent } from '../shared/sidebar-brand-logo/sidebar-brand-logo.component';
import { PrimeIcons } from 'primeng/api';
import { SidebarFooterComponent } from '../shared/sidebar-footer/sidebar-footer.component';

@Component({
  selector: 'dt-admin-sidebar',
  templateUrl: './admin-sidebar.component.html',
  styleUrls: ['./admin-sidebar.component.scss'],
  imports: [
    RouterLink,
    RouterLinkActive,
    SidebarBrandLogoComponent,
    SidebarFooterComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminSidebarComponent {
  protected readonly PrimeIcons = PrimeIcons;
}
